import { Box, Input, Text } from '@chakra-ui/react';
import React, { ChangeEventHandler } from 'react';

interface ICustomColorBoxProps {
	label: string;
	value: string;
	handleChange: ChangeEventHandler<HTMLInputElement>;
}

export const ColorBox = ({ label, value, handleChange }: ICustomColorBoxProps) => {
	return (
		<Box mx="10px">
			<Text fontSize="xs">{label}</Text>
			<Input type="color" value={value} onChange={handleChange} width="100px" h="30px" />
		</Box>
	);
};
